import authenticationService from '@/services/authenticationService'

let sessionExpired = false

const ActivityTimer = {
  init() {
    localStorage.lastActivityTimestamp = Date.now()
    // * 1000 because of ms
    // 20 * 60 * 1000 = 20 minutes
    const MINUTES = 12 * 60 // 12 hours
    const maxInactivity = MINUTES * 60 * 1000

    var activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart']

    activityEvents.forEach(function (eventName) {
      document.addEventListener(
        eventName,
        this.throttle(() => {
          this.activity()
        }, 1000),
        true
      )
    }, this)

    // check if the maxInactivity time has expired, every 5 seconds
    setInterval(
      async function () {
        if (
          !sessionExpired &&
          Date.now() - parseInt(localStorage.lastActivityTimestamp) > maxInactivity
        ) {
          sessionExpired = true
        }
      },
      5000,
      this
    )
  },
  // wrapper method to prevent the callback function to be called too often
  throttle(callback, wait, immediate = false) {
    let timeout = null
    let initialCall = true

    return function () {
      const callNow = immediate && initialCall
      const next = () => {
        callback.apply(this, arguments)
        timeout = null
      }

      if (callNow) {
        initialCall = false
        next()
      }

      if (!timeout) {
        timeout = setTimeout(next, wait)
      }
    }
  },

  async activity() {
    if (sessionExpired) {
      sessionExpired = false
      localStorage.lastActivityTimestamp = Date.now()
      window.alert('Uw sessie is verlopen, wilt u opnieuw inloggen?')
      await authenticationService.logout()
    }
    localStorage.lastActivityTimestamp = Date.now()
  },
}

export default ActivityTimer
